import { MarketingLayout } from "@/components/MarketingLayout";
import { PageHeader } from "@/components/ui/PageHeader";
import { FAQ } from "@/components/landing/FAQ";

export default function FaqPage() {
  return (
    <MarketingLayout>
      <PageHeader title="Frequently asked" accent="questions." />
      <FAQ hideHeader />
    </MarketingLayout>
  );
}
